import { Injectable } from '@angular/core';

@Injectable()
export class TabItemHelperService {

  constructor() { }

  private buildWorkerQueryParams(backLink: string, siteOwnerId?: number): any {
    const queryParams: any = {};

    if (backLink) {
      queryParams.backLink = backLink;
    }

    if (siteOwnerId) {
      queryParams.siteOwnerId = siteOwnerId;
    }

    return queryParams;
  }

  public getWorkerSectionTabItems(routeRole: string, backLink: string, selectedWorkerId?, siteOwnerId?): any[] {
    if (routeRole === 'authorising-officer') {
      return [
        { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/details', title: 'Details', queryParams: this.buildWorkerQueryParams(backLink, siteOwnerId) },
        { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/manage-competencies', title: 'Competencies', queryParams: this.buildWorkerQueryParams(backLink, siteOwnerId) },
      ];
    }

    if (routeRole === 'power-station-owner') {
      return [
        { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/details', title: 'Details', queryParams: this.buildWorkerQueryParams(backLink, siteOwnerId) },
        { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/manage-competencies', title: 'Competencies', queryParams: this.buildWorkerQueryParams(backLink, siteOwnerId) },
        { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/sites', title: 'Sites', queryParams: this.buildWorkerQueryParams(backLink, siteOwnerId) },
      ];
    }

    if (routeRole === 'power-station-manager') {
      return [
        { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/details', title: 'Details', queryParams: this.buildWorkerQueryParams(backLink, siteOwnerId) },
        { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/manage-competencies', title: 'Competencies', queryParams: this.buildWorkerQueryParams(backLink, siteOwnerId) },
      ];
    }

    if (routeRole === 'site-owner' || routeRole === 'site-delegate') {
      return [
        { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/details', title: 'Details', queryParams: this.buildWorkerQueryParams(backLink, siteOwnerId) },
        { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/manage-competencies', title: 'Competencies', queryParams: this.buildWorkerQueryParams(backLink, siteOwnerId) },
        { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/sites', title: 'Sites', queryParams: this.buildWorkerQueryParams(backLink, siteOwnerId) },
      ];
    }

    if (routeRole === 'admin' || routeRole === 'support') {
      if (siteOwnerId) {
        return [
          { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/details', title: 'Details', queryParams: this.buildWorkerQueryParams(backLink, siteOwnerId) },
          { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/sites', title: 'Sites', queryParams: this.buildWorkerQueryParams(backLink, siteOwnerId) },
          { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/edit-sites', title: 'Edit Sites', queryParams: this.buildWorkerQueryParams(backLink, siteOwnerId) },
          { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/manage-competencies', title: 'Competencies', queryParams: this.buildWorkerQueryParams(backLink, siteOwnerId) },
        ];
      } else {
        return [
          { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/details', title: 'Details', queryParams: this.buildWorkerQueryParams(backLink) },
          { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/sites', title: 'Sites', queryParams: this.buildWorkerQueryParams(backLink) },
          { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/edit-sites', title: 'Edit Sites', queryParams: this.buildWorkerQueryParams(backLink) },
          { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/manage-competencies', title: 'Competencies', queryParams: this.buildWorkerQueryParams(backLink) },
        ];
      }
    }

    if (routeRole === 'contractor-manager') {
      return [
        { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/details', title: 'Details', queryParams: this.buildWorkerQueryParams(backLink) },
        { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/sites', title: 'Sites', queryParams: this.buildWorkerQueryParams(backLink) },
        { path: '/' + routeRole + '/workers/' + selectedWorkerId + '/manage-competencies', title: 'Competencies', queryParams: this.buildWorkerQueryParams(backLink) },
      ];
    }

    return [
      { path: '/' + routeRole + '/workers/' + selectedWorkerId, title: 'Details', queryParams: { backLink: backLink } },
    ];
  }

}
